<template>
<div>
  <v-row>
    <page-title :value="$t('nap.templateList')"></page-title>
    <v-spacer />
    <v-btn  color="primary" variant="flat">
      <v-icon start>mdi-plus</v-icon>
      {{ $t('nap.newCreate') }}
    </v-btn>
  </v-row>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'

export default defineComponent({
  name: 'NapTemplateList',

  components: {
    PageTitle
  },
})
</script>